import { producaov2 as api } from "../../../../services/apis";
import React, { useState, useEffect, useCallback } from "react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import swal from "sweetalert";
import { Progress, Modal, Icon, Header } from "semantic-ui-react";
import copy from 'copy-to-clipboard';

import {
  SemanticTable,
  Select,
  FieldContainer,
  ModalContentContainer,
} from "./styles";
import { Button } from "semantic-ui-react";
import { limpaTituloCurso } from "../../../../utils/Utils";

const Pedido = (props) => {
  const [validade, setValidade] = useState("");

  useEffect(() => {}, []);

  const getStatus = (order) => {
    if (expiredBoleto(order)) {
      return "Boleto Expirado";
    }

    if (order.fila_espera) {
      return "Fila de Espera";
    }

    if (order.status === 1 && order.pagamento === "") {
      return "Método de pagamento não definido";
    }

    switch (order.status) {
      case 1:
        return "Aguardando Pagamento";
      case 2:
        return "Pendente";
      case 3:
        return "Transação aceita";
      case 4:
        return "Entrada";
      case 5:
        return "Desistiu";
      case 6:
        return "Estorno";
      case 7:
        return "Crédito";
      default:
        return "Pendente";
    }
  };

  const expiredBoleto = (order) => {
    if (order.pagamento !== "boleto") {
      return false;
    }

    const orderDate = new Date(order.data_cadastro);
    const todayDate = new Date();

    if (
      orderDate.getDate() + 3 < todayDate.getDate() &&
      order.dataPagto01 === "" &&
      order.status === 1
    ) {
      return true;
    }

    return false;
  };

  const ddmmyyyy = (dataParse) => {
    const data = new Date(dataParse);
    const dia = data.getDate().toString();
    const diaF = dia.length === 1 ? "0" + dia : dia;
    const mes = (data.getMonth() + 1).toString(); // +1 pois no getMonth Janeiro começa com zero.
    const mesF = mes.length === 1 ? "0" + mes : mes;
    const anoF = data.getFullYear();
    return diaF + "/" + mesF + "/" + anoF;
  };

  const getFormattedValidate = (date) => {
    if (!date) {
      return "";
    }

    if (date === "Acesso Vitalício") {
      return date;
    }

    const dateObject = new Date(date);

    return ddmmyyyy(dateObject);
  };

  const copyToClipBoard = (value) => {
    copy(value);

    swal("Copiado com sucesso",`https://voitto.com.br/pagar/${props.pedido.id}`,"success");
  };

  const returnFormPagamento = () => {
    if (props.pedido.pagamento){
      return props.pedido.pagamento;
    }else if (props.pedido.forma01){
      return props.pedido.forma01;
    }else if (props.pedido.forma02){
      return props.pedido.forma02;
    }else if (props.pedido.forma03){
      return props.pedido.forma03;
    }
    return"Sem registro"
  };

  const formatInvestiment = (pedido) => {

    // Verificando quais destes valores está disponivel para retornar o preço do investimento
    const price = [
      pedido?.pedido?.json?.total,
      pedido?.pedido?.json?.valor_pago,
      pedido?.pedido?.valor_pago
    ].find(price => !Number.isNaN(+price));

    return `R$ ${(+price).toFixed(2).replace(".", ",")}` ;
  }

  return (
    <>
      <SemanticTable.Row>
        <SemanticTable.Cell>{props.pedido.id}</SemanticTable.Cell>
        <SemanticTable.Cell>{props.pedido.id_pedido}</SemanticTable.Cell>
        <SemanticTable.Cell>
          {getFormattedValidate(props?.pedido?.data_cadastro)}
        </SemanticTable.Cell>
        <SemanticTable.Cell>
          {getFormattedValidate(props.pedido.validade)}
        </SemanticTable.Cell>
        <SemanticTable.Cell>{getStatus(props.pedido)}</SemanticTable.Cell>
        <SemanticTable.Cell>{props.pedido.voucher}</SemanticTable.Cell>
        <SemanticTable.Cell>{returnFormPagamento()}</SemanticTable.Cell>
        {/* <SemanticTable.Cell onClick={() =>
              copyToClipBoard(
                `https://voitto.com.br/pagarx/${props.pedido.id}`
              )
            } >{`https://voitto.com.br/pagarx/${props.pedido.id}`}</SemanticTable.Cell>*/}
        <SemanticTable.Cell> 
          {limpaTituloCurso(props?.pedido?.curso?.curso)}
        </SemanticTable.Cell>
        <SemanticTable.Cell>
          {props.pedido.pedido.json.pagamento === "free"
            ? "Gratuito"
            : formatInvestiment(props?.pedido)}
        </SemanticTable.Cell>
      </SemanticTable.Row>
    </>
  );
};

export default Pedido;
